import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Products } from "@/components/site/Products";
import { Reviews } from "@/components/site/Reviews";
import { Location } from "@/components/site/Location";
import { Contact } from "@/components/site/Contact";
import { WhatsAppFAB } from "@/components/site/WhatsAppFAB";

function App() {
  return (
    <div className="App bg-[#FDFBF7]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Products />
        <Reviews />
        <Location />
      </main>
      <Contact />
      <WhatsAppFAB />
    </div>
  );
}

export default App;
